import requestv2 from "~/utils/http-v2";

const revenueApi = {
	gets : async (params) => {
		const url = 'v2/revenue';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/revenue';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/revenue/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/revenue/${id}`;
		return await requestv2.delete(url);
	},
	status : async (params) => {
		const url = `v2/revenue/status/${params.id}`;
		return await requestv2.post(url, params);
	},
	transfer : async (params) => {
		const url = `v2/revenue/transfer/${params.id}`;
		return await requestv2.post(url, params);
	},
	pay : async (params) => {
		const url = `v2/revenue/pay/${params.id}`;
		return await requestv2.post(url, params);
	},
};

export default revenueApi;